import { Component, Input, Output, EventEmitter } from '@angular/core';

import { BasePTypeComponent } from '../base-ptype/base-ptype.component';

@Component({
  selector: 'digital-platform-button',
  standalone: true,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent extends BasePTypeComponent {
  @Input() buttonType = 'button';
  @Input() color = 'primary';
  @Input() size = 'lg';
  @Input() backgroundType = 'light';
  @Input() label = '';
  @Input() style = '';
  @Input() className = '';
  @Input() disabled = false;

  @Output() onclick = new EventEmitter();
}
